import React from "react";
import { Loader2 } from "lucide-react";
import { Button } from "components/ui/button";

// Shared loading / error / empty chrome for every targeting map layer (H2H pins,
// D2D polygons) so the states stay visually identical across channels.

export const CenteredSpinner = ({ label }: { label: string }) => (
  <div className="flex h-full w-full flex-col items-center justify-center gap-3 bg-page text-center">
    <Loader2 className="size-6 animate-spin text-muted-foreground" />
    <p className="text-sm text-muted-foreground">{label}</p>
  </div>
);

// Covers the map while the layer's areas are being fetched.
export const LoadingOverlay = ({ label }: { label: string }) => (
  <div className="absolute inset-0 z-10 flex items-center justify-center bg-page/80">
    <CenteredSpinner label={label} />
  </div>
);

// Shown when the layer's fetch fails; the retry control re-runs it.
export const ErrorOverlay = ({ message, onRetry }: { message: string; onRetry: () => void }) => (
  <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 bg-page/90 text-center">
    <p className="text-sm text-muted-foreground">{message}</p>
    <Button type="button" variant="outline" onClick={onRetry} data-cypress-id="targeting-map-retry">
      Retry
    </Button>
  </div>
);

// Non-blocking banner pinned to the top of the map (e.g. "no areas for city").
export const EmptyBanner = ({ message }: { message: string }) => (
  <div className="pointer-events-none absolute inset-x-0 top-4 flex justify-center">
    <p className="rounded-md bg-card px-4 py-2 text-sm text-muted-foreground shadow">{message}</p>
  </div>
);
